import React from "react";
import { Box, MenuItem, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import AddIcon from "@icons/myicons/plus-circled.svg?react";
import EditIcon from "@icons/myicons/edit.svg?react";
import DeleteIcon from "@icons/myicons/trash-delete-bin-2.svg?react";
import { ButtonWithActionMenu } from "@components/ButtonWithActionMenu";

interface InvestmentActionMenuItemsProps {
  onAddBooking: () => void;
  onEdit: () => void;
  onDelete: () => void;
  handleCloseMenu?: () => void;
}

export const InvestmentActionMenuItems = ({
  onAddBooking,
  onEdit,
  onDelete,
  handleCloseMenu,
}: InvestmentActionMenuItemsProps) => {
  const { t } = useTranslation();

  const handleAddBookingClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    onAddBooking();
    handleCloseMenu?.();
  };

  const handleEditClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    onEdit();
    handleCloseMenu?.();
  };

  const handleDeleteClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    onDelete();
    handleCloseMenu?.();
  };

  return (
    <>
      <MenuItem
        onClick={handleAddBookingClick}
        data-testid="add-booking-investment-menu-item"
      >
        <Box display="flex" alignItems="center" gap={3}>
          <AddIcon width={20} height={20} />
          <Typography variant="body3">
            {t("investment.protocolTable.actions.addBooking")}
          </Typography>
        </Box>
      </MenuItem>
      <MenuItem
        onClick={handleEditClick}
        data-testid="edit-investment-menu-item"
      >
        <Box display="flex" alignItems="center" gap={3}>
          <EditIcon width={20} height={20} />
          <Typography variant="body3">
            {t("investment.protocolTable.actions.edit")}
          </Typography>
        </Box>
      </MenuItem>
      <MenuItem
        onClick={handleDeleteClick}
        data-testid="delete-investment-menu-item"
      >
        <Box display="flex" alignItems="center" gap={3} color="error.main">
          <DeleteIcon />
          <Typography variant="body3">
            {t("investment.protocolTable.actions.delete")}
          </Typography>
        </Box>
      </MenuItem>
    </>
  );
};

interface Props {
  onAddBooking: () => void;
  onEdit: () => void;
  onDelete: () => void;
}

export const InvestmentActionMenu = (props: Props) => (
  <ButtonWithActionMenu testId="investment-action-menu-button">
    <InvestmentActionMenuItems {...props} />
  </ButtonWithActionMenu>
);
